
<div class="card-headd text-center">
    <div class="row details-header">
        <button type="button" class="btn-dt-retourr mt-1" (click)="returnToList()">
            <div class="icon-position">
                <i class="fa-solid fa-arrow-left fa-icon-style fa-lg"></i>
            </div>
        </button>
        <div class="row">
            <div class=" row details-spinner">
                <div class="col">
                    <!--  <ng-container >
                        <div class="col-12">
                            <div class="spinner-style">
                                <mat-spinner [diameter]="30"></mat-spinner>
                            </div>
                        </div>

                    </ng-container> -->
                </div>
                <div>
                    <button type="button" class="btn-load" id="clear" (click)="Actualise()">
                        <i class="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>


            <app-shared-button-enrg  data-toggle="modal"   data-target="#Actions" (click)="getStatusAutorise(true)"class="ml-2" [type]="'o'"
            [label]="Enregistrer" [allowed_to_update]="allowed_to_update" class="ml-2"
                [label]="Enregistrer"></app-shared-button-enrg>
        </div>
    </div>

</div>


<div class="row custem-margin">
    <div class="col-4 w-100">
        <div class="card-head w-100 float-left">
            <div class="row">
                <div class="col-1 text-right p-0" *ngIf="prospectOpp?.type_opportunite === 'entrepise'">
                    <svg  width="63" height="61" viewBox="0 0 50 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="50" height="48.4127" fill="white"/>
                        <path d="M3.17188 45.5916C3.25124 44.9765 3.35045 44.3631 3.41553 43.7464C3.82135 39.9215 4.22214 36.0959 4.61791 32.2694C4.63443 32.0774 4.71311 31.8961 4.84201 31.7529C4.97091 31.6096 5.14301 31.5123 5.33219 31.4758C7.15045 30.8773 8.96155 30.2583 10.783 29.6702C11.0949 29.5694 11.2052 29.4392 11.1909 29.1107C11.1624 28.4583 11.1909 27.8043 11.175 27.1512C11.1752 26.9891 11.1153 26.8327 11.0068 26.7123C8.74052 24.8153 7.27674 22.1305 6.90997 19.198C6.16235 18.9361 6.09172 18.817 6.07743 18.021C5.97843 16.4145 6.21687 14.8051 6.77743 13.2964C7.39928 11.5967 8.47778 10.1014 9.89436 8.97497C11.3109 7.84851 13.0107 7.13451 14.8068 6.91147C17.1824 6.54046 19.6124 7.03297 21.6561 8.29972C23.6997 9.56647 25.2219 11.5236 25.9465 13.8162C26.3496 15.0623 26.5186 16.3722 26.4449 17.6797C26.4497 17.8646 26.3831 18.0443 26.259 18.1814C26.1348 18.3185 25.9627 18.4026 25.7782 18.4162C25.5679 19.3908 25.4235 20.3472 25.152 21.2662C24.5321 23.3489 23.3109 25.202 21.6417 26.5932C21.5421 26.6691 21.4631 26.7689 21.4121 26.8833C21.361 26.9977 21.3396 27.1231 21.3497 27.248C21.3671 27.8583 21.3758 28.4702 21.3497 29.0797C21.336 29.1468 21.3362 29.216 21.3502 29.2831C21.3643 29.3501 21.3919 29.4135 21.4314 29.4695C21.4708 29.5255 21.5213 29.5728 21.5798 29.6085C21.6382 29.6443 21.7033 29.6677 21.7711 29.6773C23.4862 30.2258 25.1838 30.8353 26.9028 31.3638C27.5973 31.5773 27.9885 31.925 27.9687 32.6694C27.9748 32.7712 27.9877 32.8725 28.0076 32.9726H45.0393C46.2909 32.9726 46.8235 33.5075 46.8243 34.7639C46.8243 38.144 46.806 41.525 46.837 44.9051C46.8883 45.299 46.8051 45.6987 46.6008 46.0394C46.3966 46.3801 46.0832 46.6418 45.7116 46.7821H3.17188V45.5916ZM17.775 14.225C14.4863 14.9983 11.3539 16.328 8.51314 18.1567C8.45827 18.2015 8.41335 18.2572 8.38124 18.3204C8.34912 18.3835 8.33053 18.4527 8.32664 18.5234C8.32603 18.7913 8.35127 19.0587 8.40203 19.3218C8.77379 21.6544 9.93676 23.7881 11.6957 25.3646C12.7799 26.3517 14.1548 26.9607 15.6143 27.1003C17.0738 27.24 18.5392 26.9028 19.7909 26.1392C21.5866 24.9855 22.9416 23.2609 23.6377 21.2432C23.9811 20.3255 24.1774 19.3594 24.2195 18.3805C20.9965 18.6512 18.6925 17.5194 17.775 14.221V14.225ZM29.283 45.3004H45.3298V36.4908C44.8989 37.2432 44.5036 37.8996 44.1393 38.5742C43.9932 38.8762 43.7602 39.1276 43.4702 39.2962C43.1801 39.4647 42.8463 39.5428 42.5116 39.5202C41.2338 39.5107 39.9552 39.5202 38.6766 39.5202H38.0925C38.0925 39.7781 38.1068 39.9885 38.0925 40.1956C38.052 40.6718 37.8147 40.9535 37.3457 40.9623C36.1531 40.9855 34.9602 40.9855 33.7671 40.9623C33.6631 40.9678 33.5591 40.9508 33.4623 40.9124C33.3654 40.8739 33.2781 40.815 33.2062 40.7396C33.1343 40.6642 33.0797 40.5741 33.0459 40.4755C33.0122 40.3769 33.0002 40.2723 33.0108 40.1686C33.0028 39.9623 33.0108 39.7551 33.0108 39.5543H28.6862L29.283 45.3004ZM24.975 17.0337C24.9901 15.8841 24.7774 14.743 24.3492 13.676C23.9209 12.6091 23.2857 11.6375 22.4801 10.8173C21.6745 9.9971 20.7145 9.34453 19.6554 8.89722C18.5963 8.44992 17.4592 8.21674 16.3095 8.21113C15.1599 8.20553 14.0205 8.42761 12.9571 8.86456C11.8937 9.30152 10.9274 9.9447 10.1138 10.757C9.30026 11.5693 8.65558 12.5347 8.21699 13.5974C7.77839 14.6601 7.55455 15.7991 7.55838 16.9488C7.58616 16.9488 7.61949 16.9631 7.63775 16.9488C7.77425 16.8742 7.90997 16.798 8.04172 16.7154C11.1073 14.8027 14.4809 13.4351 18.0131 12.6734C18.8274 12.4948 19.1354 12.7281 19.2036 13.5773C19.2323 14.3083 19.495 15.0107 19.9531 15.581C20.4112 16.1513 21.0405 16.5593 21.7481 16.7448C22.8163 16.9151 23.8951 17.0103 24.9766 17.0297L24.975 17.0337ZM21.3862 31.0726V45.3019H27.81C27.8004 45.1472 27.7981 45.0202 27.7846 44.8948C27.3692 40.9731 26.9557 37.0512 26.5441 33.1289C26.5486 33.0183 26.5137 32.9097 26.4455 32.8224C26.3773 32.7352 26.2803 32.6751 26.1719 32.6527C24.9171 32.2488 23.6687 31.8273 22.4179 31.4123L21.3862 31.0726ZM11.1616 31.0829C11.0028 31.1273 10.8671 31.1583 10.7362 31.2019C9.51236 31.6104 8.2888 32.0199 7.06552 32.4305C5.9941 32.7892 6.01473 32.7916 5.90045 33.9178C5.60918 36.7988 5.29727 39.6773 4.99489 42.5575C4.89965 43.4686 4.80838 44.3829 4.71473 45.294H11.1616V31.0829ZM44.8179 34.444H28.1417C28.2592 35.5448 28.3862 36.6146 28.4782 37.6885C28.5044 37.9892 28.6108 38.0646 28.8933 38.0615C30.129 38.0488 31.3647 38.0567 32.6004 38.0551C32.7243 38.0551 32.8481 38.0385 33.0028 38.0273C33.0028 37.8139 33.0028 37.6305 33.0028 37.4488C33.0163 36.8932 33.2552 36.6146 33.7965 36.6067C34.9605 36.5898 36.1245 36.5898 37.2885 36.6067C37.8084 36.6139 38.052 36.8781 38.0885 37.4051C38.1028 37.6099 38.0885 37.8162 38.0885 37.9964C38.1378 38.0182 38.1891 38.0353 38.2417 38.0472C39.1647 38.0512 40.0877 38.0599 41.0108 38.0543C41.5802 38.1516 42.1642 38.1193 42.7195 37.9599C43.1465 37.717 43.329 37.0392 43.6131 36.5488C44.0116 35.8654 44.3997 35.1781 44.8179 34.444ZM12.6322 27.7488C12.6322 28.8234 12.6243 29.8313 12.6425 30.8385C12.655 30.9081 12.6828 30.9741 12.724 31.0316C12.7652 31.0891 12.8187 31.1367 12.8806 31.171C13.9272 31.7096 14.9801 32.2358 16.0393 32.7496C16.1733 32.8106 16.326 32.8161 16.4639 32.7646C17.5359 32.2461 18.6015 31.7141 19.6608 31.1686C19.718 31.1378 19.7677 31.0947 19.8064 31.0424C19.8451 30.9902 19.8718 30.93 19.8846 30.8662C19.9012 29.8472 19.8949 28.8281 19.8949 27.7543C18.7615 28.2984 17.5201 28.5803 16.2629 28.5794C15.0057 28.5784 13.7648 28.2945 12.6322 27.7488ZM15.2068 34.8123C14.4227 35.0718 13.7306 35.3186 13.0266 35.5265C12.9628 35.5364 12.9016 35.559 12.8466 35.5929C12.7915 35.6268 12.7439 35.6713 12.7063 35.7238C12.6687 35.7764 12.6421 35.836 12.6278 35.899C12.6136 35.962 12.6121 36.0272 12.6235 36.0908C12.6377 39.0154 12.6322 41.9392 12.6322 44.8638V45.3067H15.0766C14.5949 44.3424 14.1584 43.4075 13.6647 42.5027C13.5334 42.2701 13.4524 42.0125 13.4271 41.7465C13.4018 41.4806 13.4328 41.2123 13.5179 40.9591C14.0925 38.944 14.6298 36.9202 15.2068 34.8099V34.8123ZM19.8949 45.3186V36.5591C19.8949 35.6615 19.8949 35.6599 19.0576 35.3813C18.502 35.1964 17.9465 35.0178 17.3393 34.8194C17.3893 35.0218 17.4187 35.1448 17.4497 35.2654C17.9901 37.2496 18.5258 39.2289 19.0766 41.2067C19.1323 41.3812 19.1521 41.5651 19.1349 41.7475C19.1177 41.9298 19.0639 42.1068 18.9766 42.2678C18.5116 43.1591 18.0727 44.0646 17.6274 44.9662C17.5751 45.0718 17.5378 45.1853 17.4838 45.3178L19.8949 45.3186ZM16.3076 36.6162L16.2282 36.6012C15.7854 38.2281 15.3438 39.8551 14.9036 41.4821C14.8838 41.5615 14.8908 41.6452 14.9235 41.7202C15.3568 42.6027 15.7965 43.4813 16.2671 44.4234C16.6489 43.6591 16.9687 42.9464 17.3552 42.2726C17.478 42.0704 17.5544 41.8436 17.579 41.6084C17.6036 41.3731 17.5757 41.1354 17.4973 40.9123C17.0727 39.4869 16.6996 38.0472 16.3076 36.6139V36.6162ZM34.4766 39.4805H36.6123V38.0877H34.4766V39.4805ZM12.6512 34.1226L14.3655 33.5535L12.6512 32.6932V34.1226ZM19.8735 34.1226V32.7012L18.1719 33.5472L19.8735 34.1226Z" fill="black"/>
                        <path d="M24.8223 8.72556L23.7461 7.81524C25.443 5.80365 27.7078 4.35135 30.2439 3.64847C32.7801 2.9456 35.4693 3.02492 37.9596 3.87605C40.4499 4.72718 42.6252 6.31045 44.2006 8.41856C45.776 10.5267 46.6781 13.0614 46.7888 15.6908C46.8995 18.3202 46.2137 20.9217 44.8211 23.1548C43.4285 25.3879 41.3941 27.1484 38.9841 28.2059C36.5742 29.2634 33.9011 29.5685 31.3149 29.0813C28.7286 28.5941 26.3498 27.3374 24.4898 25.4756L25.5374 24.5232C26.8051 25.7795 28.3471 26.7245 30.0419 27.284C31.7367 27.8436 33.5383 28.0023 35.3048 27.7478C38.2197 27.3953 40.879 25.9107 42.7088 23.6145C44.552 21.3761 45.4915 18.5294 45.3429 15.6337C45.1943 12.7379 43.9682 10.0024 41.9056 7.96445C40.7762 6.82575 39.4184 5.9392 37.9216 5.36316C36.4248 4.78712 34.8229 4.53465 33.2215 4.62239C31.6125 4.68172 30.0339 5.07749 28.5872 5.78421C27.1406 6.49093 25.858 7.4929 24.8223 8.72556Z" fill="black"/>
                        <path d="M29.0622 8.8211L28.3249 7.65602C29.8975 6.66447 31.7122 6.12386 33.571 6.09318C35.4299 6.0625 37.2614 6.54294 38.8659 7.48207C40.4703 8.42119 41.786 9.78294 42.6694 11.4187C43.5528 13.0545 43.9699 14.9015 43.8754 16.7582C43.7808 18.6149 43.1781 20.4099 42.133 21.9474C41.088 23.485 39.6407 24.706 37.9492 25.4772C36.2576 26.2484 34.3867 26.5403 32.5406 26.3209C30.6945 26.1015 28.9441 25.3792 27.4805 24.233L28.3487 23.1219C29.3534 23.9017 30.5164 24.4525 31.7562 24.7358C32.996 25.0192 34.2828 25.0283 35.5265 24.7624C37.4418 24.3849 39.1654 23.3512 40.4003 21.8394C41.7384 20.2445 42.4631 18.2242 42.4437 16.1424C42.4244 14.0606 41.6623 12.0541 40.2948 10.4843C38.9273 8.91458 37.0442 7.8847 34.9847 7.5802C32.9252 7.27571 30.8247 7.71661 29.0614 8.82349L29.0622 8.8211Z" fill="black"/>
                        <path d="M29.8203 15.4467L30.3592 14.0975C31.2901 14.4689 32.2044 14.8054 33.0917 15.2006C33.2696 15.2909 33.4688 15.3307 33.6678 15.3159C33.8667 15.3011 34.0577 15.2321 34.2203 15.1165C35.6076 14.2919 37.0171 13.5054 38.4536 12.6855L39.1719 13.934C39.0362 14.0173 38.9195 14.0927 38.7997 14.1617C37.3362 14.9998 35.8632 15.8284 34.4124 16.6808C34.2183 16.8084 33.9943 16.8834 33.7625 16.8983C33.5307 16.9132 33.299 16.8675 33.0901 16.7657C32.0243 16.3133 30.9409 15.8974 29.8203 15.4467Z" fill="black"/>
                        <path d="M34.4328 8.25977V9.65183H33.0352V8.25977H34.4328Z" fill="black"/>
                        <path d="M41.6979 15.5293V16.9253H40.2852V15.5293H41.6979Z" fill="black"/>
                        <path d="M33.0273 22.793H34.421V24.1969H33.0273V22.793Z" fill="black"/>
                        </svg>

                </div>
                <div class="col-1 text-right p-0" *ngIf="prospectOpp?.type_opportunite !== 'entrepise'">
                    <svg  width="63" height="61" viewBox="0 0 63 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="50" height="48.4127" fill="white"/>
                        <rect width="63" height="61" fill="white"/>
                        <path d="M4.00484 58.9721C4.00484 58.207 4.00484 57.4418 4.00484 56.6767C3.99863 54.6683 3.99344 52.5966 4.02245 50.5654C4.10714 46.6738 5.56058 42.9366 8.12739 40.0104C10.6504 37.053 14.1453 35.0921 17.9843 34.4802C19.3649 34.3064 20.7558 34.2272 22.1472 34.243C22.7853 34.2357 23.444 34.2285 24.0976 34.2026C24.1847 34.2026 24.2727 34.2026 24.3628 34.2026H24.6073H24.6301H24.9139H25.5592V33.5572C25.5592 33.3356 25.5592 33.117 25.5592 32.9026V32.8726C25.5592 32.219 25.5664 31.6006 25.5385 30.9708C25.5112 30.7722 25.4363 30.5831 25.3202 30.4197C25.204 30.2563 25.05 30.1234 24.8714 30.0324C23.4932 29.1466 22.3065 27.9936 21.3814 26.6415C20.4562 25.2894 19.8115 23.7656 19.4852 22.1601C19.2971 21.2163 19.201 20.2564 19.1982 19.294C19.1703 16.8018 19.1754 14.2713 19.1806 11.8237C19.1806 11.0903 19.1806 10.3573 19.1806 9.62466C19.129 7.81288 19.7428 6.04494 20.906 4.65495C22.0693 3.26497 23.7014 2.34923 25.4939 2.08079C25.578 2.06498 25.6596 2.03779 25.7363 2H47.4719C47.4719 2.40708 47.4719 2.81415 47.4719 3.21294C47.4719 4.58644 47.4719 6.00965 47.358 7.38004C47.2596 8.2795 46.9747 9.14855 46.5215 9.93169C46.0684 10.7148 45.4568 11.3949 44.726 11.9283C44.5079 12.0911 44.3333 12.305 44.2175 12.5512C44.1017 12.7974 44.0483 13.0684 44.062 13.3401C44.062 13.7427 44.0658 14.1453 44.0734 14.5479C44.091 16.2808 44.1086 18.0624 44.0548 19.8047C44.0375 21.8749 43.4943 23.9067 42.4762 25.7094C41.4581 27.5121 39.9985 29.0263 38.2345 30.11C37.9667 30.2606 37.7485 30.4858 37.6063 30.7581C37.4642 31.0305 37.4042 31.3383 37.4338 31.6441C37.4576 32.0201 37.4556 32.4137 37.4525 32.7949V32.8208C37.4525 33.0052 37.4525 33.1885 37.4525 33.3729C37.4551 33.4818 37.479 33.5891 37.5229 33.6888C37.5312 33.7095 37.5405 33.7333 37.5519 33.7665L37.7031 34.1984H38.161H38.3681H38.5867C38.6654 34.1984 38.7452 34.1984 38.8249 34.1984C39.4889 34.2253 40.1601 34.2326 40.8085 34.2409C42.2279 34.2263 43.6467 34.3066 45.0554 34.4812C48.4813 35.0588 51.6417 36.6905 54.0964 39.1491C56.5511 41.6077 58.1778 44.7707 58.7499 48.1975C58.8926 49.1034 58.9704 50.0182 58.983 50.9352C59.0047 53.0068 59.0006 55.1137 58.9975 57.1563C58.9975 57.7612 58.9975 58.3661 58.9975 58.9711L4.00484 58.9721ZM6.56745 56.858H13.2516V50.208H15.3761V56.8435H47.6594V50.2246H49.7839V56.8466H56.8616V56.2013C56.8616 55.6557 56.8616 55.1137 56.8616 54.575V54.4715C56.8616 53.2513 56.8709 51.9855 56.8533 50.7518C56.7808 47.6358 55.7261 44.6223 53.8396 42.1412C51.9531 39.66 49.3313 37.838 46.3481 36.9351C44.6823 36.4844 42.9591 36.282 41.2342 36.3343C40.764 36.3343 40.274 36.3415 39.8431 36.3477H39.8017C39.3635 36.354 38.913 36.3602 38.4707 36.3602H38.2024C38.1052 36.3615 38.0093 36.3824 37.9203 36.4215C37.8313 36.4607 37.7511 36.5173 37.6845 36.5881C37.6741 36.5984 37.6669 36.6057 37.6565 36.614L37.4235 36.8076V38.9756H36.6756C36.126 38.938 35.5746 39.0185 35.0587 39.2116C34.5427 39.4047 34.0741 39.706 33.6842 40.0952C33.2942 40.4845 32.9921 40.9526 32.7981 41.4682C32.6041 41.9838 32.5227 42.535 32.5593 43.0847C32.5593 43.729 32.5593 44.3733 32.5593 45.0321V45.6183H30.4348V45.1771C30.4348 44.4168 30.4348 43.6813 30.4348 42.9459C30.4613 42.4179 30.377 41.8902 30.1871 41.3968C29.9972 40.9034 29.706 40.4553 29.3323 40.0813C28.9587 39.7074 28.5108 39.4158 28.0175 39.2256C27.5243 39.0353 26.9967 38.9505 26.4686 38.9767H25.5364V36.2545L24.8714 36.2742C24.2447 36.2928 23.6118 36.3001 22.9997 36.3073C21.5858 36.3229 20.2631 36.3374 18.9092 36.4814C15.8458 36.8871 12.9877 38.2466 10.7401 40.3673C8.49242 42.488 6.96917 45.2623 6.38619 48.297C6.12434 50.1429 6.04005 52.0097 6.13448 53.8717C6.14898 54.6123 6.16348 55.3768 6.15313 56.1215C6.15267 56.2207 6.17321 56.3189 6.21338 56.4095C6.25354 56.5002 6.31244 56.5814 6.38619 56.6477L6.56745 56.858ZM27.6857 33.1657C27.6857 34.2015 27.6857 35.1659 27.6981 36.1375C27.7091 36.348 27.7805 36.5509 27.9037 36.722C28.027 36.893 28.1969 37.0249 28.3932 37.1018C29.4016 37.4434 30.3114 38.0258 31.0439 38.7985L31.5069 39.2677L31.9657 38.7943C32.6841 38.0224 33.5864 37.4451 34.5884 37.1163C34.7864 37.0409 34.9586 36.9102 35.0846 36.7398C35.2105 36.5694 35.2849 36.3665 35.299 36.1551C35.3145 35.1731 35.3125 34.214 35.3114 33.1978V31.526L34.5232 31.7052C33.5861 31.9182 32.6283 32.0263 31.6674 32.0273C30.5936 32.0242 29.5238 31.897 28.4792 31.6482L27.6878 31.4649L27.6857 33.1657ZM30.9734 13.5691C28.9487 13.5691 26.9247 13.5691 24.9014 13.5691C24.4421 13.5527 23.9841 13.6283 23.5542 13.7912C23.1244 13.9541 22.7314 14.2011 22.3982 14.5178C22.065 14.8344 21.7984 15.2144 21.6139 15.6354C21.4294 16.0564 21.3307 16.51 21.3237 16.9696C21.2711 18.1898 21.2942 19.412 21.3931 20.6292C21.6235 23.0627 22.7167 25.3335 24.4753 27.0312C26.2338 28.729 28.5416 29.7417 30.9817 29.8863C31.1661 29.8956 31.3536 29.9008 31.5379 29.9008C33.9206 29.9544 36.2452 29.1618 38.0987 27.6636C39.9523 26.1654 41.2148 24.0588 41.662 21.7178C41.9097 19.9981 42.0212 18.2615 41.9956 16.5242C42.0038 15.7702 42.0121 14.9923 42.0453 14.2361L42.0743 13.5628L30.9734 13.5691ZM34.7345 4.1255C31.3991 4.1255 28.822 4.13171 26.3806 4.14621C25.1488 4.16301 23.965 4.62632 23.0491 5.45006C22.1331 6.27381 21.5473 7.40201 21.4004 8.6251C21.3367 9.26457 21.3232 9.90806 21.36 10.5496C21.3683 10.819 21.3776 11.0903 21.3776 11.3472V12.1666L22.1772 11.9708C22.4031 11.9149 22.6278 11.8537 22.8516 11.7926C23.3092 11.6553 23.7762 11.5515 24.2489 11.4819C24.5739 11.4456 24.9008 11.4293 25.2277 11.4332C25.4245 11.4332 25.6224 11.4332 25.8202 11.4404C26.0181 11.4477 26.2345 11.4477 26.4417 11.4477C27.7137 11.4477 28.9784 11.4477 30.2432 11.4404H30.3209C31.6785 11.437 33.0361 11.4346 34.3937 11.4332C36.4891 11.4332 38.2117 11.4415 39.8162 11.4612H39.8866C40.6889 11.4751 41.4845 11.3138 42.218 10.9885C42.9515 10.6633 43.6052 10.1819 44.1335 9.57805C44.68 8.90423 45.0673 8.11573 45.2666 7.27134C45.4658 6.42695 45.4719 5.54847 45.2843 4.70142L45.2097 4.25601L44.7653 4.17315H44.7488C44.6639 4.15091 44.5765 4.13908 44.4888 4.13793H44.4546H39.8462H39.5987L34.7345 4.1255Z" fill="black"/>
                        </svg>

                </div>
                <div class="col-10 ml-4 pl-1 p-3">
                    <div class="row">
                        <div class="col-12" ></div>
                        <div class="col text-nowrap ">
                             {{'languages.opportunite.opportuniteNum' | translate}} :
                            <label class="label-card-info">
                                <a class="a-style row"
                                    >
                                    {{realopp_id}}
                                </a>
                            </label>
                            <br>
                            {{'languages.opportunite.createdBy' | translate}} :
                            <!-- <p *ngIf="informationsContrat?.contrat?.nom_commerciale !== null"> </p>&nbsp; -->
                            <label class="label-card-info">{{opportunite_details?.opportunite_details?.commerciaux_nom }} {{opportunite_details?.opportunite_details?.commerciaux_prenom }}</label>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
    <div class="col-4 w-100">
        <div class="card-head w-100" >
            <div class="row justify-content-center">
                <div class="col-12" *ngIf="prospectOpp?.type_opportunite !== 'entrepise'">
                    <label class="label-card-info"></label>
                </div>
                    <div class="text-nowrap col-12">
                        {{'languages.opportunite.creationDate' | translate}} :
                        <label class="label-card-info">
                            {{opportunite_details?.opportunite_details?.date_depot}}
                        </label>
                    </div>
                    <div class="text-nowrap col-12" *ngIf="prospectOpp?.type_opportunite === 'entrepise'">
                        {{'languages.prospect.interlocuteur' | translate}} :
                        <label class="label-card-info">
                            {{opportunite_details?.opportunite_details?.main_prospect_name}}
                        </label>
                    </div>
                    <div class="text-nowrap col-12" *ngIf="prospectOpp?.type_opportunite !== 'entrepise'">
                        {{'languages.opportunite.adherantName' | translate}} :
                        <label class="label-card-info">
                            {{opportunite_details?.opportunite_details?.main_prospect_name}}
                        </label>
                    </div>
                    <div class="text-nowrap col-12"   *ngIf="prospectOpp?.type_opportunite === 'entrepise'">
                        {{'languages.opportunite.societe' | translate}} :
                        <label class="label-card-info">
                        {{prospectOpp?.RS}}
                        </label>
                    </div>


            </div>
        </div>
    </div>
    <div class="col-4 w-100 ">
        <div class="card-head mr-2 w-100">
            <div class="row">
                <div class="col ">
                    <svg data-toggle="modal" *ngIf="allowed_to_update" data-target="#Actions" (click)="showModalUpdateStatut()"
                        class=" float-right cursor-pointer" width="25" height="25" viewBox="0 0 25 25" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12.5" cy="12.5" r="12.5" fill="#D9D9D9" />
                        <path
                            d="M14.0857 6.91356L18.0862 10.9143L9.39929 19.6016L5.83251 19.9953C5.35502 20.0482 4.95159 19.6444 5.00471 19.1669L5.40158 15.5975L14.0857 6.91356ZM20.5606 6.31793L18.6822 4.43946C18.0962 3.85351 17.146 3.85351 16.56 4.43946L14.7929 6.20668L18.7934 10.2074L20.5606 8.44015C21.1465 7.85389 21.1465 6.90388 20.5606 6.31793Z"
                            fill="#474747" />
                    </svg>
                    <br>
                    {{'languages.organisme.Campagne' | translate}} :
                    <label class="label-card-info">
                        {{campagne?.libelle}}
                    </label>
                    <br>
                        {{'languages.opportunite.statusActuel' | translate}} :
                    <label class="VAD text-center border-0"
                    [style.background]="opportunite_details?.opportunite_details?.etat_background">
                    <p [style.color]="opportunite_details?.opportunite_details?.etat_color">
                        {{opportunite_details?.opportunite_details?.etat}}
                    </p>
                </label>


                </div>
            </div>
        </div>

    </div>
</div>


<div class="row">
    <div class="col ml-3 custem-W">
        <div class="card card-2 m-auto border-0" style=" min-width: 195px;">
            <div class="card-2-element col " >
                <button class="button-style focus-style" (click)="getCurrentPath('prospect')"
                    [ngClass]="{'switched-menu':nav_switched=='prospect'}">
<i class="fa-solid fa-user-tie opportunities-details-navbar-logo fa-lg"></i>
                    {{'languages.opportunite.details.label_prospect' | translate}}
                </button>
            </div>
            <div class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('contrat-actuel')"
                    [ngClass]="{'switched-menu':nav_switched=='contrat-actuel'}">
<i class="fa-solid fa-circle-info opportunities-details-navbar-logo fa-lg"></i>
                    {{'languages.opportunite.details.infoSpecific' | translate}}
                </button>
            </div>
            <div *ngIf="isbien==true" class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('objet-assurer')"
                    [ngClass]="{'switched-menu':nav_switched=='objet-assurer'}">
<i class="fa-solid fa-object-ungroup opportunities-details-navbar-logo fa-lg"></i>
                     {{'languages.opportunite.details.objetBienAssure' | translate}}
                </button>
            </div>

            <div class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('ticket')"
                    [ngClass]="{'switched-menu':nav_switched=='ticket'}">
<i class="fa-solid fa-ticket-simple opportunities-details-navbar-logo fa-lg"></i>
                  {{'languages.navbar.OppDetailsTickets' | translate}}
                </button>
            </div>
            <div class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('tache')"
                    [ngClass]="{'switched-menu':nav_switched=='tache'}">
                    <i class="fa-solid fa-list-check opportunities-details-navbar-logo fa-lg"></i>
                    To-do list
                </button>
            </div>
            <div class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('planification')"
                    [ngClass]="{'switched-menu':nav_switched=='planification'}">
<i class="fa-solid fa-calendar-check opportunities-details-navbar-logo fa-lg"></i>
                    {{'languages.opportunite.details.label_planification' | translate}}
                </button>
            </div>

            <div class="col card-2-element" *ngIf="communication">
                <button class="button-style focus-style" (click)="getCurrentPath('communication')" [ngClass]="{'switched-menu':nav_switched=='communication'}">
                    <i class="fa-solid fa-comments opportunities-details-navbar-logo fa-lg"></i>
                    {{'languages.opportunite.label_communication' | translate}}
                </button>
            </div>

            <div class="col card-2-element" *ngIf="histAccess || histCommAccess">
                <button class="button-style focus-style" (click)="getCurrentPath('historique')"
                    [ngClass]="{'switched-menu':nav_switched=='historique'}">
<i class="fa-solid fa-clock-rotate-left opportunities-details-navbar-logo fa-lg"></i>
                    {{'languages.opportunite.details.label_history' | translate}}
                </button>
            </div>

            <div class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('porteDocument')"
                    [ngClass]="{'switched-menu':nav_switched=='porteDocument'}">
<i class="fa-solid fa-file-import opportunities-details-navbar-logo fa-lg"></i>
                   {{'languages.document.PorteDocuments' | translate}}
                </button>
            </div>

            <div class="col card-2-element">
                <button class="button-style focus-style" (click)="getCurrentPath('commentaire')"
                    [ngClass]="{'switched-menu':nav_switched=='commentaire'}">
<i class="fa-solid fa-comment-dots opportunities-details-navbar-logo fa-lg"></i>
                     {{'languages.opportunite.details.commentaire_label' | translate}}
                </button>
            </div>
        </div>

        <div class="">
            <shared-tags [opportunity_id]="opportunity_id" [isReadOnly]="allowed_to_update"></shared-tags>
        </div>
    </div>

    <div class="col ">
        <div class="row">
            <div class="col-12">
                <div class=" row cardOpportunite">

                    <div class="col-12">
                        <app-status-bar [listOfProcesses]="listOfProcess"></app-status-bar>
                    </div>
                </div>
            </div>
            <div class="row card-nav" [ngClass]="{'cover': !allowed_to_update}">
                <div class=" col-12">
                    <button class="button btn-action-primary btn-dt-details" data-toggle="modal" data-target="#Parrainge">
                        <div class="icon">
                            <i class="fa-solid fa-user icon-style "></i>
                        </div>
                        <span>
                            {{'languages.prospect.Parrainage' | translate}}
                        </span>
                    </button>
                    <button class="button btn-action-primary btn-dt-details" (click)="goToComparateur()" *ngIf="comparateurAppear">
                        <div class="icon">
                            <i class="fa-solid fa-scale-balanced icon-style"></i>
                        </div>
                        <span>
                            {{'languages.role.Comparateur' | translate}}
                        </span>
                    </button>
                    <button class="button btn-action-primary btn-dt-details"  (click)="goToTarificateur()" *ngIf="tarifAppear">
                        <div class="icon">
                            <i class="fa-solid fa-calculator icon-style"></i>
                        </div>
                        <span>
                            {{'languages.role.Tarificateur' | translate}}
                        </span>
                    </button>
                    <button class="button btn-action-primary btn-dt-details" (click)="AddAffaire()">
                        <div class="icon iconAff ml-2">
                            <i class="fa-solid fa-circle-plus icon-btn-add"></i>
                        </div>
                        <span>
                            {{'languages.opportunite.details.label_addaffaire' | translate}}
                        </span>
                    </button>
                </div>
            </div>
            <div class="col customMargin" >
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

<div *ngIf="appearModel">
    <div class="modal fade" id="Actions" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog  actions-dialog" role="document">
            <div class="modal-content modal-first w-100">
                <div class="modal-header d-flex align-items-center  justify-content-center ">
                    <div class="row w-100">
                        <div class="col-3">

                        </div>
                        <div class="col-6 d-flex align-items-center  justify-content-center">
                            <p class="text-center d-flex align-items-center  title m-0 justify-content-center">
                                {{'languages.opportunite.updateOpp' | translate}}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                            (click)="resetStatus()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                </div>
                <div class="modal-body" >
                    <div class="row text-center justify-content-center" *ngIf="appear">
                        <div class="row">
                            <p class="custemPara">
                                {{'languages.opportunite.confirmUpdating' | translate}} </p>
                        </div>
                        <div class="row d-flex justify-content-center mt-2 mb-3">
                            <div class="col-6">
                                <button type="button" class="btn-dt-save-popup sizeC mr-3"
                                    [allowed_to_update]="allowed_to_update_affaire" (click)="saveOpportuniteDetails()"
                                    data-dismiss="modal" aria-label="Close">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                                    {{'languages.affaire.saveQuit' | translate}}
                                </button>
                            </div>
                            <div class="col-6">
                                <button type="button" class="changeStatus" (click)="statutappear()">
                                    <span class="mb-1">{{'languages.affaire.changeStatut' | translate}}</span>
                                    <i class="fa-solid fa-arrow-right fa-icon-style   ml-3 fa-lg"></i>
                                </button>
                            </div>



                        </div>
                    </div>
                    <div class="row text-center justify-content-center paddingBlock" *ngIf="!appear && !step">
                        <ng-container *ngIf="show_loading_status">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <div
                                        style="width: min-content; margin: auto; margin-bottom: 50px; margin-top: 50px">
                                        <mat-spinner [diameter]="30"></mat-spinner>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <div class="row text-center justify-content-center w-100" *ngIf="!show_loading_status">
                            <ng-container *ngFor="let item of status_autorise.listCategory">
                                <div class="col w-100 paddingBlock scrollAp">
                                    <div class="row w-100">
                                        <div class="col-12 style-div title text-center">
                                             {{'languages.listing.Service' | translate}} : <b class="title-custem">{{item.label}}</b>
                                        </div>
                                        <div class="col-12 w-100">
                                            <div class="row w-100">
                                                <ng-container *ngFor="let status of item.listactions">
                                                    <div class="col-3 text-center style-div">
                                                        <button
                                                            [disabled]="(status.dependance!==status_id && status.dependance!==null)|| status.access_sup==false"
                                                            [ngStyle]="{'opacity':(status.dependance!==status_id && status.dependance!==null)|| !status.access_sup ? 0.4 : none}"
                                                            (click)="updateSubActionsList(status?.id); appearS()"
                                                            class="btn-affect border-0"
                                                            [style]="{'background-color': status?.color, 'color': status?.couleur_police}">

                                                            <p>{{status?.etat}}<span
                                                                    *ngIf="status.etat == prospect.etat"
                                                                    style="color: darkred">*</span>
                                                            </p>
                                                        </button>
                                                    </div>
                                                </ng-container>

                                            </div>
                                            <div class="row w-100 mt-3 justify-content-center" *ngIf="!appear">
                                                <button type="reset"  (click)="resetStatus()" class="btn-dt-cancel-popup" data-dismiss="modal"
                                                    aria-label="Close">
<i class="fa-solid fa-circle-xmark fa-lg mr-1 fa-icon-style"></i>
                                                     {{'languages.buttons.annuler' | translate}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div *ngIf="step||!appear">
                        <div class=" scrollAp  justify-content-center align-items-center">
                            <ng-container *ngIf="show_loading">
                                <div class="row mb-3 mt-3">
                                    <div class="text-center m-auto ">
                                        <mat-spinner [diameter]="50"></mat-spinner>

                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!show_loading">
                                <div class="row" *ngIf="subStatusList.length>0 && step">
                                    <div class=" col-4 text-center style-div" *ngFor="let status of subStatusList">
                                        <button class="btn-affect border-0 w-100"
                                            [ngStyle]="{'opacity':(status.dependance!==status_id && status.dependance!==null) || status.access_sup==false ? 0.4 : none}"
                                            [disabled]="status.etat == prospect.etat || (status.dependance!==status_id && status.dependance!==null)|| status.access_sup==false"
                                            (click)="updateSubActionsList(status?.id)" class="btn-affect"
                                            [style]="{'background-color': status.color, 'color': status.couleur_police}">

                                            <p>{{status?.etat}} <span *ngIf="status.etat == prospect.etat"
                                                    style="color: darkred">*</span></p>
                                        </button>
                                    </div>
                                </div>

                                <div class="row mt-4 " *ngIf="subStatusList.length == 0 && step">
                                    <div class="col-12 text-center">
                                        <h2 class="text-center m-auto custemPara">
                                          {{'languages.opportunite.confirmUpdateStatut' | translate}}
                                        </h2>
                                    </div>
                                </div>
                                <div class="row mt-2" *ngIf="subStatusList.length==0 && step" class="row">
                                    <div class="col-6 col-6 d-flex justify-content-end">
                                        <button (click)="changeAction()" class="btn-dt-save-popup mr-3"
                                            data-dismiss="modal" aria-label="Close">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                                             {{'languages.alerts.Oui' | translate}}
                                        </button>
                                    </div>
                                    <div class="col-6 d-flex justify-content-start">
                                        <button type="reset" class="btn-dt-cancel-popup " data-dismiss="modal"
                                            (click)="resetStatus()">
<i class="fa-solid fa-circle-xmark fa-icon-style mr-1 fa-lg"></i>
                                             {{'languages.alerts.Non' | translate}}
                                        </button>
                                    </div>



                                </div>
                            </ng-container>

                        </div>
                        <div class="row mt-3" *ngIf="subStatusList.length>0 && step">
                            <div class="col-12">
                                <button type="reset" class="btn-dt-cancel-popup" data-dismiss="modal" aria-label="Close"
                                    (click)="resetStatus()">
<i class="fa-solid fa-circle-xmark fa-icon-style mr-1 fa-lg"></i>
                                     {{'languages.buttons.annuler' | translate}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="subActionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
    aria-hidden="true">
    <div class="modal-dialog model-lg modal-dialog-centered" role="document">
        <div class="modal-content  w-100" >
            <div class="modal-header text-center">
                <div class="row w-100">
                    <div class="col-3"></div>
                    <div class="col">
                        <h2 class="text-center justify-content-center w-100" id="exampleModalLongTitle">
                            {{'languages.opportunitiesdetails.label.changeraction' | translate}}
                        </h2>
                    </div>
                </div>
                <div class="row w-100">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-bodyy paddingBlock ">
                <ng-container *ngIf="show_loading">
                    <div class="row mb-3 mt-3">
                        <div class="text-center m-auto ">
                            <mat-spinner [diameter]="50"></mat-spinner>

                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!show_loading" class="">
                    <div class="row " *ngIf="subStatusList.length>0">
                        <ng-container *ngFor="let status of subStatusList">
                            <div class="col-6 text-center style-div">
                                <button class="btn-affect border-0"
                                    [ngStyle]="{'opacity':(status.dependance!==status_id && status.dependance!==null) || status.access_sup==false ? 0.4 : none}"
                                    [disabled]="status.etat == prospect.etat || (status.dependance!==status_id && status.dependance!==null)|| status.access_sup==false"
                                    (click)="updateSubActionsList(status?.id)" class="btn-affect"
                                    [style]="{'background-color': status.color, 'color': status.couleur_police}">

                                    <p>{{status?.etat}} <span *ngIf="status.etat == prospect.etat"
                                            style="color: darkred">*</span></p>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <div class="row  " *ngIf="subStatusList.length==0">
                        <h2 class="text-center m-auto custemPara">
                            {{'languages.opportunite.details.confirmChangeStatut' | translate}}
                        </h2>
                    </div>
                    <div *ngIf="subStatusList.length==0" class="d-flex justify-content-around">
                        <div>
                            <button (click)="changeAction()" class="btn-dt-save-popup " data-dismiss="modal"
                                aria-label="Close">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                              {{'languages.alerts.Oui' | translate}}
                            </button>
                        </div>
                        <div>
                            <button type="reset" class="btn-dt-cancel-popup " data-dismiss="modal">
<i class="fa-solid fa-circle-xmark fa-icon-style mr-1 fa-lg"></i>
                              {{'languages.alerts.Non' | translate}}
                            </button>
                        </div>

                    </div>
                </ng-container>
            </div>

        </div>
    </div>
</div>























<!--Parrainge Modal-->
<div class="modal fade" id="Parrainge" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog model-lg modall" role="document">
        <div class="modal-content custem-modal-content" >
            <div class="modal-header ">
                <h3 class="text-center  title justify-content-center m-0 w-100">{{'languages.prospect.Parrainage' | translate}}</h3>
                <ng-container *ngIf="show_loading_add">
                    <div class="row mb-3 mt-3">
                        <div class="text-center m-auto ">
                            <mat-spinner [diameter]="20"></mat-spinner>

                        </div>
                    </div>
                </ng-container>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body scroll">
                <div class="conatainer-modal-elements">
                    <div style="margin-top: 50px" class="row">
                        <div class="form-group col-6">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="{{'languages.prospect.nom' | translate}}" [(ngModel)]="parrainage.nom_parrainage" name="nom" #nom="ngModel" required>
                            </mat-form-field>
                            <div *ngIf="nom.invalid && (nom.dirty || nom.touched)" class="message-erreur">
                                <div *ngIf="nom.errors.required">
<i class="fa-solid fa-triangle-exclamation"></i>
                               {{'languages.prospect.check_nom' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="example-full-width">
                                <input matInput placeholder="{{'languages.prospect.prenom' | translate}}" [(ngModel)]="parrainage.prenom_parrainage" name="prenom" #prenom="ngModel" required>
                            </mat-form-field>
                            <div *ngIf="prenom.invalid && (prenom.dirty || prenom.touched)" class="message-erreur">
                                <div *ngIf="prenom.errors.required">
<i class="fa-solid fa-triangle-exclamation"></i>
                                   {{'languages.prospect.check_prenom' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="full-width" appearance="fill" style="margin-top: -11px;" floatLabel="always">
                                <input ng2TelInput matInput name="tel" (keypress)="numberOnly($event)" [(ngModel)]="parrainage.tel_parrainage" [ng2TelInputOptions]="{initialCountry: telCountry}">
                                <mat-icon matSuffix>phone</mat-icon>
                            </mat-form-field>

                        </div>
                        <div class="col-6">
                            <mat-form-field class="example-full-width">
                                <input matInput [(ngModel)]="parrainage.mail_parrainage" type="email" placeholder="{{'languages.prospect.email' | translate}}" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" name="mail" #mail="ngModel">
                            </mat-form-field>
                            <div *ngIf="mail.invalid && (mail.dirty || mail.touched)" class="message-erreur">
                                <!-- <div *ngIf="mail.errors.required">
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    Adresse Email est obligatoire!
                                </div> -->
                                <div *ngIf="mail.errors.pattern">
<i class="fa-solid fa-triangle-exclamation"></i>
                                    {{'languages.prospect.check_emailInvalide' | translate}}
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <mat-form-field class="example-full-width" style="margin-top: 11px;">
                                <input matInput placeholder="{{'languages.prospect.CodePostal' | translate}}" [(ngModel)]="parrainage.cp_parrainage" type="number" maxlength="5" (ngModelChange)="getVilleList()" name="cp" #cp="ngModel">
                            </mat-form-field>
                            <!-- <div *ngIf="cp.invalid && (cp.dirty || cp.touched)" class="message-erreur">
                                <div *ngIf="cp.errors.required">
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    Code Postal est obligatoire!
                                </div>
                            </div> -->
                        </div>
                        <div class="col-6">
                            <ng-container *ngIf="loader_villes">
                                <mat-spinner [diameter]="20"></mat-spinner>
                            </ng-container>
                            <mat-form-field class="example-full-width" appearance="fill">
                                <mat-select placeholder="{{'languages.prospect.Ville' | translate}}" [ngModelOptions]="{standalone: true}" [(ngModel)]="parrainage.ville_parrainage" name="ville" #ville="ngModel">
                                    <mat-option *ngFor="let ville of listVille" [value]="ville.id">
                                        {{ville.ville}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!-- <div *ngIf="ville.invalid && (ville.dirty || ville.touched)" class="message-erreur">
                                <div *ngIf="ville.errors.required">
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    Ville est obligatoire!
                                </div>
                            </div> -->
                        </div>
                        <br>
                        <div class="col-6">
                            <mat-form-field class="example-full-width" appearance="fill">

                                <mat-select  placeholder="{{'languages.prospect.RelationParrainage' | translate}}" [(ngModel)]="parrainage.relation_parrainage" name="relation" #relation="ngModel" required>
                                    <mat-option value="Ascendant">
                                      {{'languages.prospect.Ascendant' | translate}}
                                    </mat-option>
                                    <mat-option value="Descendant">
                                       {{'languages.prospect.Descendant' | translate}}
                                    </mat-option>
                                    <mat-option value="Parrainage">
                                       {{'languages.prospect.Parrainage' | translate}}
                                    </mat-option>
                                    <mat-option value="Amitié">
                                    {{'languages.prospect.Amitie' | translate}}
                                    </mat-option>
                                    <mat-option value="Colocataires">
                                   {{'languages.prospect.Colocataires' | translate}}
                                    </mat-option>
                                    <mat-option value="Voisinage">
                                      {{'languages.prospect.' | translate}}
                                    </mat-option>
                                    <mat-option value="Collègues">
                                     {{'languages.prospect.Collegues' | translate}}
                                    </mat-option>
                                    <mat-option value="Famille-Autre">
                                       {{'languages.prospect.Famille_Autre' | translate}}
                                    </mat-option>
                                    <mat-option value="Frère-Soeur">
                                       {{'languages.prospect.Frere_Soeur' | translate}}
                                    </mat-option>
                                    <mat-option value="Conjoint">
                                        {{'languages.prospect.Conjoint' | translate}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="relation.invalid && (relation.dirty || relation.touched)"
                                class="message-erreur">
                                <div *ngIf="relation.errors.required">
<i class="fa-solid fa-triangle-exclamation"></i>
                                   {{'languages.prospect.check_parrainage' | translate}}
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-6">
                            <mat-form-field class="example-full-width" appearance="fill">
                                <mat-select placeholder="Type de rendez-vous" [ngModelOptions]="{standalone: true}" [(ngModel)]="parrainage.type_opp" name="rdv" #rdv="ngModel" required>
                                    <mat-option *ngFor="let list of listRDV" [value]="list.id">
                                        {{list.libelle}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="rdv.invalid && (rdv.dirty || rdv.touched)" class="message-erreur">
                                <div *ngIf="rdv.errors.required">
                                    <i class="fa-solid fa-triangle-exclamation"></i>
                                    Type de rendez-vous est obligatoire!
                                </div>
                            </div>
                        </div> -->
                        <div class="col-12 horsCmp-style">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="toggle1">{{'languages.prospect.campHorsCamp' | translate}} :</label>

                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <div class="checkbox-container" style="font-size: 2em;margin-left: -6px;">
                                            <input (change)="SelectListCycleVie()" [(ngModel)]="horsCamp"
                                                class="checkbox" type="checkbox" id="toggle1">
                                            <div class="checkbox-visual" style="margin-left: 15px">
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group col-12">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-select (change)="SelectCycleVie()" [ngModelOptions]="{standalone: true}" [(ngModel)]="selected_cyclevie" placeholder="{{'languages.prospect.CycleVieSystème' | translate}}">
                                                <mat-option *ngFor="let cv of listCycleVieStr" value="{{cv}}">
                                                    {{cv}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div *ngIf="listCampagnes" class="col-12">
                                    <div class="form-group col-12">
                                        <mat-form-field class="example-full-width" appearance="fill">
                                            <mat-select [(ngModel)]="parrainage.id_campagne" name="campagne" placeholder="{{'languages.organisme.Campagne' | translate}}"  >
                                                <mat-option *ngFor="let comp of listCampagnes" value="{{comp.id}}">
                                                    {{comp.campagne}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 p-0 mt-3 ">
                      
                            <textarea [(ngModel)]="parrainage.comm_parrainage"  placeholder="{{'languages.prospect.linkProspect' | translate}}" class="form-control textAreaa" cols="50" rows="6">
                </textarea>
                        </div>
                    </div>
                    <div class="row text-center justify-content-center  mt-3" >
                        <button type="button" class="btn-dt-save-popup mr-2" (click)="onSubmit()">
<i class="fa-solid fa-circle-check fa-lg mr-1"></i>
                            {{'languages.buttons.enregistrer' | translate}}
                        </button>

                        <button type="button"  (click)="resetStatus()" class="btn-dt-cancel-popup ml-2 " #closebuttonParrainage
                        data-dismiss="modal">
<i class="fa-solid fa-circle-xmark fa-lg fa-icon-style mr-1"></i>
                        {{'languages.buttons.annuler' | translate}}
                    </button>
                       

                          
                  
                        
                    </div>
                    <!-- </form> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-------------------Button Doublon---------------------------->
<div class="modal fade" id="Doublon" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog model-lg" role="document">
        <div class="modal-content" style="width: 60rem; margin-left: -135px;">
            <div class="modal-header">
                <h2 style=" color: #20307f;"> {{ "languages.opportunite.DoublonProbables" | translate}}</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <form [formGroup]="formDouble">
                        <div class="table-responsive p-3">
                            <table class="table align-items-center ">
                                <thead class="thead-light" style="text-align: center;">
                                    <tr>
                                        <th></th>
                                        <th>{{'languages.prospect.FicheProspect' | translate}}
                                        </th>
                                        <th>{{'languages.prospect.nom' | translate}}
                                        </th>
                                        <th>{{'languages.prospect.prenom' | translate}}
                                        </th>
                                        <th>{{'languages.opportunite.opportunites' | translate}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="main-table-body" style="text-align: center;">
                                    <ng-container *ngIf="listDoublon?.length>0">

                                        <tr *ngFor="let doublon of listDoublon">
                                            <td>
                                                <input type="checkbox" name="selectProspect"
                                                    formControlName="selectProspect" value="{{doublon?.prospect.id}}"
                                                    (change)="getProspectDoublon($event)">
                                            </td>
                                            <td>
                                                <button class="btn-fich-prospect">
                                                    
                                                        <i class="fa-solid fa-up-right-from-square icon-style fa-lg"
                                                        style="margin-left: 5px; color: #9b9b9b;"></i>
                                                </button>
                                            </td>
                                            <td>
                                                {{doublon?.prospect.name}}
                                            </td>
                                            <td>
                                                {{doublon?.prospect.surname}}
                                            </td>
                                            <td>
                                                <ul style="text-align: left;">
                                                    <li *ngFor="let opp of doublon?.prospect.opportunite">
                                                        | {{opp.camp_libelle}} | {{opp.cycle_libelle}} | {{opp.etat}}
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <hr>
                        <div class="col-12 text-center">
                            <button (click)="setFussionProspectDoublon()" class="btn-stat" data-dismiss="modal">
<i class="fa-solid fa-down-left-and-up-right-to-center icon-style fa-lg"></i>
                               {{'languages.buttons.Fusionner' | translate}}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>


</div>
